import React, { useState } from "react";
import "./App.css";

function App() {

const [form, setForm] = useState({
firstName:"",
lastName:"",
email:"",
password:"",
confirmPassword:"",
phone:"",
gender:""
});

const handleChange = (e) =>{
setForm({...form,[e.target.name]:e.target.value});
};

const handleSubmit = (e) =>{
e.preventDefault();
alert("Registered Successfully");
};

return (

<div className="container">
<h2 className="text-center mt-4">SIGNUP HERE</h2>

<form className="signup-form" onSubmit={handleSubmit}>

<input
type="text"
name="firstName"
placeholder="First Name"
className="form-control"
onChange={handleChange}
/>

<input
type="text"
name="lastName"
placeholder="Last Name"
className="form-control"
onChange={handleChange}
/>

<input
type="email"
name="email"
placeholder="Email"
className="form-control"
onChange={handleChange}
/>

<input
type="password"
name="password"
placeholder="Password"
className="form-control"
onChange={handleChange}
/>

<input
type="password"
name="confirmPassword"
placeholder="Confirm Password"
className="form-control"
onChange={handleChange}
/>

<input
type="text"
name="phone"
placeholder="Phone Number"
className="form-control"
onChange={handleChange}
/>

<select
name="gender"
className="form-control"
onChange={handleChange}
>

<option>Select Gender</option>
<option>Male</option>
<option>Female</option>

</select>

<div className="mt-3">
<input type="radio" name="type"/> Student
<input type="radio" name="type" className="ms-3"/> Professional
</div>

<div className="mt-2">
<input type="checkbox"/> Agree to terms and conditions
</div>

<button className="btn btn-success mt-3">
REGISTER
</button>

</form>

</div>

);
}

export default App;